import type { Image as ImageType } from 'types/capi/shared';

import { Dialog } from '~/components/Dialog';
import Image, { smallImageOptions } from '~/components/Image';

type Props = {
  children: React.ReactNode;
  heading: string;
  image?: ImageType;
  onDismiss: () => void;
};

export default function ExitNotificationDialog({
  children,
  heading,
  image,
  onDismiss
}: Props) {
  return (
    <Dialog
      isOpen={true}
      onDismiss={onDismiss}
      className="z-50 rounded-2xl bg-white p-4 pt-6 text-black max-md:mx-4"
    >
      <div className="flex w-auto max-w-[500px] flex-col items-center justify-center gap-6 text-center">
        <h2 className="text-lg font-bold">{heading}</h2>
        {image && (
          <Image
            className="h-[45px] w-[80px] object-cover"
            src={image.url}
            alt={image.alt}
            loading="eager"
            {...smallImageOptions({ pad: true })}
          />
        )}
        {children}
      </div>
    </Dialog>
  );
}
